module.exports = __webpack_public_path__ + "media/country_flags/gt-c67be7ab.png";